import styled from 'styled-components';
import {
  Flex,
} from 'web-styled';

export const Preview = styled(Flex).attrs({
  column: true,
  spacing: 10,
})`
  min-width: 500px;
  max-width: 600px;
  margin-right: 15px;
`;

export const TableWrapper = styled.div`
  width: 100%;
  height: 600px;
  overflow: auto;

  table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
    border-collapse: collapse;
    border-right: 1px solid #eceeef;
    border-bottom: 1px solid #eceeef;
    table-layout: auto;

    th,
    tr,
    td {
      padding: 0.5rem;
      vertical-align: top;
      border-top: 1px solid #eceeef;
      border-left: 1px solid #eceeef;
      min-width: 150px;
      height: 40px;
      box-sizing: border-box;
      white-space: nowrap;
      width: auto;
    }

    thead th {
      vertical-align: bottom;
      border-bottom: 2px solid #eceeef;
    }

    tbody + tbody {
      border-top: 2px solid #eceeef;
    }
  }
`;
